// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__Ky1Ja","inputDescription":"styles_inputDescription__TndAb"};